module.exports = __webpack_public_path__ + "img/tarot-major-arcana-05.8ba50b64.png";